import styles from './styles.module.scss';

const PageNotFound = () => {
  return <div className={styles.container}>Page Not Found</div>;
};

export default PageNotFound;
